import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a46c476"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade show",
  id: "confirmDialog",
  tabindex: "-1",
  "aria-labelledby": "confirmDialogTitle",
  "aria-modal": "true",
  role: "dialog",
  style: {"display":"block","padding-left":"0px"}
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content h-100" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LaravelPagination = _resolveComponent("LaravelPagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
            (_ctx.enableX)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('cancel')))
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Søg",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchString) = $event)),
                    "aria-label": "Søg",
                    "aria-describedby": "button-addon2"
                  }, null, 512), [
                    [_vModelText, _ctx.searchString]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_LaravelPagination, {
                  multiple: _ctx.multiple,
                  query: _ctx.searchString,
                  config: _ctx.config,
                  onSelected: _ctx.setSelected,
                  onUnselected: _ctx.unselected
                }, null, 8, ["multiple", "query", "config", "onSelected", "onUnselected"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$.emit('cancel')))
            }, _toDisplayString(_ctx.cancelBtn), 1),
            _createElementVNode("button", {
              disabled: !_ctx.selected,
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.okPressed && _ctx.okPressed(...args)))
            }, _toDisplayString(_ctx.okBtn), 9, _hoisted_15)
          ])
        ])
      ])
    ]),
    _hoisted_16
  ], 64))
}